import { CanActivateFn } from '@angular/router';
import { inject } from '@angular/core';
import { UrgencyService } from '../../service/urgency.service';
import { InitService } from '@infodata-group/inf-commons';
import { catchError, filter, of, switchMap, take, timeout } from 'rxjs';
import { map } from 'rxjs/operators';

export const urgencyGuard: CanActivateFn = (route, state) => {
  const urgencyService = inject(UrgencyService);
  const initService = inject(InitService);
  return initService.isConfigLoaded.pipe(
    filter((loaded) => loaded === true),
    take(1),
    timeout(5000),
    catchError(() => of(false)),
    switchMap(() => {
      return urgencyService.loadEmergencies$(true).pipe(
        map(() => true),
        catchError(() => of(false)),
      );
    }),
  );
};
